import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Calendar, Info } from 'lucide-react';
import { useCart } from '../context/CartContext';

// Routes where the bottom tab bar is hidden. Add more paths here as needed —
// the tabs' UI/behaviour stays identical everywhere else.
const HIDE_TABS_ON_ROUTES = ['/cart', '/multi-booking', '/multi-booking/review', '/multi-booking/checkout', '/multi-booking/confirmation'];

export const BottomNav = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { editBooking, editSession } = useCart();

    if (HIDE_TABS_ON_ROUTES.includes(location.pathname)) return null;
    // While adding dishes to a booking/session, keep the user in the focused edit flow.
    if (editBooking || editSession) return null;

    const navItems = [
        { path: '/', icon: Home, label: 'Home' },
        { path: '/bookings', icon: Calendar, label: 'Bookings' },
        { path: '/how-it-works', icon: Info, label: 'How it works' },
    ];

    const isActive = (path) => location.pathname === path;

    return (
        <nav className="fixed bottom-0 left-0 right-0 mx-auto max-w-[480px] h-[41px] flex items-center bg-white border-t border-gray-100 px-2 z-50 shadow-lg" data-testid="bottom-nav">
            <div className="w-full grid grid-cols-3">
                {navItems.map(({ path, icon: Icon, label, badge }) => (
                    <button
                        key={path}
                        onClick={() => navigate(path)}
                        className={`w-full flex flex-row items-center justify-center gap-1.5 py-1.5 rounded-xl transition-all duration-200 ${
                            isActive(path)
                                ? 'text-[#006f3c]'
                                : 'text-gray-400 hover:text-gray-600'
                        }`}
                        data-testid={`nav-${label.toLowerCase()}`}
                    >
                        <div className="relative">
                            <Icon className={`w-4 h-4 ${isActive(path) ? 'stroke-[2.5]' : 'stroke-2'}`} />
                            {badge > 0 && (
                                <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] flex items-center justify-center bg-[#d9ec00] text-[#006f3c] text-xs font-bold rounded-full" data-testid="cart-badge">
                                    {badge > 9 ? '9+' : badge}
                                </span>
                            )}
                        </div>
                        <span className={`text-xs font-medium ${isActive(path) ? 'font-semibold' : ''}`}>
                            {label}
                        </span>
                    </button>
                ))}
            </div>
        </nav>
    );
};
